var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.57,
    height: 16.4,
    viewBox: "0 0 16.57 16.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_vai",
    "data-name": "icona vai",
    transform: "translate(-467.913 -97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icona_vai-2",
    "data-name": "icona vai",
    d: "M.239,16.642l.409-.686C3.787,10.68,8.084,11,9.136,11.174v4.157L16,8.456,9.136,1.644V5.737h-.1c-3.815,0-5.575,1.6-5.651,1.675A9.355,9.355,0,0,0,.086,15.858ZM8.227,10.51A9.1,9.1,0,0,0,.611,14.881,8.725,8.725,0,0,1,3.783,7.868c.03-.027,1.809-1.635,5.648-1.516l.314.009V3.108l5.392,5.35-5.392,5.4V10.685l-.232-.057A6.067,6.067,0,0,0,8.227,10.51Z",
    transform: "translate(468.2 95.856)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_785",
    "data-name": "Rettangolo 785",
    transform: "translate(468 97)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4,
    height: 16.4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15.4,
    height: 15.4,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo);
export default __webpack_public_path__ + "static/media/go.2efcb8cc2305bb4ea43ce88230096e44.svg";
export { ForwardRef as ReactComponent };